import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FitlrosOrdenMedicamentosControladosEntity, MedicamentoControladoEntity, ParametrosOrdenamientosEntity, ServicioOrdenamientosService} from '../../../../services/servicio-ordenamientos.service';
import { SelectItem } from 'primeng/api';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-header-orden-medicamentos-controlados',
  templateUrl: './header-orden-medicamentos-controlados.component.html',
  styleUrls: ['./header-orden-medicamentos-controlados.component.css']
})
export class HeaderOrdenMedicamentosControladosComponent implements OnInit {

  @Input() session: boolean;
  @Input() bodyPromise: Promise<any>;
  @Input() parametros: ParametrosOrdenamientosEntity;
  @Output() filtrosSeleccionados: EventEmitter<any>;
  @Output() changeProfesional: EventEmitter<any>;
  @Output() errorGenerado: EventEmitter<any>;
  @Output() mensajeCarga: EventEmitter<any>;

  filtros: FitlrosOrdenMedicamentosControladosEntity = {} as FitlrosOrdenMedicamentosControladosEntity;

  profesionales: SelectItem[];

  medicamentosControlados: MedicamentoControladoEntity[] = [];

  profesionalSelected: number;
  medicamentoControladoSelected: number;

  constructor(private ordenamientosService: ServicioOrdenamientosService) {
    this.filtrosSeleccionados = new EventEmitter();
    this.errorGenerado = new EventEmitter();
    this.mensajeCarga = new EventEmitter();
    this.changeProfesional = new EventEmitter();
  }

  ngOnInit() {

    if (this.session) {
      this.bodyPromise.then((dataReport) => {
        this.profesionales = dataReport.profesionales;
        this.medicamentosControlados = [];
        this.resolveFiltroProfesionales(this.profesionales, dataReport.medicamentosControlados);

      });
    } else {
      // se resuelve profesionales y medicamentos
      this.getProfesionalesSaludOrdenamientosMedicamentosControlados();
    }

  }

  private buildMedicamentos(medicamentosControlados: MedicamentoControladoEntity[]) {

    let i = 0;
    for (const medicamentoControlado of medicamentosControlados) {
      if (medicamentoControlado.dataItem.uncoprofesionalespec === this.profesionalSelected) {
        this.medicamentosControlados.push({value : medicamentoControlado.value, label : medicamentoControlado.label, dataItem : medicamentoControlado.dataItem});
      }
      if (i === 0) {
        this.medicamentoControladoSelected = medicamentoControlado.value;
      }
      i++;
    }

  }

  private resolveFiltroProfesionales(profesionales, medicamentosControlados) {

    if (profesionales && profesionales.length > 0) {
      if (!this.profesionalSelected) {
        this.profesionalSelected = profesionales[0].value;
      }
    }

    if (this.session) {
      this.buildMedicamentos(medicamentosControlados);
    } else {
      if (profesionales && profesionales.length > 0) {
        this.onChangeSelectProfesional(null);
      }
    }
  }

  onGenerar() {
    if (!this.session) {
      // recargar los filtros
      this.getProfesionalesSaludOrdenamientosMedicamentosControlados();
    }

    if (this.profesionalSelected <= 0) {
      this.errorGenerado.emit('Debe seleccionar un <strong>Profesional</strong>.');
    } else if (this.medicamentoControladoSelected <= 0) {
      this.errorGenerado.emit('Debe un <strong>Medicamento</strong>.');
    } else {

      let dataItem;
      for (const medicamentoControlado of this.medicamentosControlados) {
        if (this.medicamentoControladoSelected === medicamentoControlado.value) {
          dataItem = medicamentoControlado.dataItem;
          break;
        }
      }

      this.filtros.profesional  = this.profesionalSelected;
      this.filtros.medicamentoControladoSelected = this.medicamentoControladoSelected;
      if (this.session) {
        this.filtros.dataItem = dataItem;
      }
      this.filtrosSeleccionados.emit(this.filtros);
    }
  }

  onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('reporte-orden-escritas').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();

    popupWin.document.write(`
      <html lang="ES">
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO"
          crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  public async onChangeSelectProfesional($event: any) {


    this.medicamentosControlados.length = 0;

    if ($event !== undefined && $event !== null) {
      this.changeProfesional.emit();
    }

    // al seleccionar profesional se consulta el filtro de medicamentos
    const response = await this.ordenamientosService.getMedicamentosControlados(this.parametros.codigo, this.parametros.uncoHc, this.profesionalSelected);
    response.subscribe((data: any) => {

      for (const item of data['#result-set-1']) {
        this.medicamentosControlados.push({value : item.unco_ordenmedicacontrol, label : item.medicamento, dataItem : null});
      }

    }, (err: HttpErrorResponse) => {
      console.error('Error HeaderOrdenMedicamentosControladosComponent.onChangeSelectProfesional()', err);
      this.errorGenerado.emit('Error al consultar medicamentos del profesional seleccionado');
    });
  }

  private async getProfesionalesSaludOrdenamientosMedicamentosControlados() {

    this.mensajeCarga.emit('Cargando profesionales ...');

    const response = await this.ordenamientosService.getProfesionalesSaludOrdenamientosMedicamentosControlados(this.parametros.codigo, this.parametros.uncoHc);
    response.subscribe((data: any) => {

      this.profesionales = [];
      for (const item of data['#result-set-1']) {
        this.profesionales.push({value : item.unco_prfsl_espcldd, label : item.profesional_salud});
      }
      this.resolveFiltroProfesionales(this.profesionales, []);
    }, (err: HttpErrorResponse) => {
      console.error('Error HeaderOrdenMedicamentosControladosComponent.getProfesionalesSaludOrdenamientosMedicamentosControlados()', err);
      this.errorGenerado.emit('Error al obtener listado de profesionales, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    });
  }

}
